import { Logger } from '@mytmpvpn/mytmpvpn-common/logger'

export const logger = Logger.create()
